import { Entity } from '@nx-data/nx-data';

export class SellableSubscriptionsEntity extends Entity {
  public subscriptionPackageMappings: {
    id: string;
    subscriptionPackageId: string;
    localizedText: {
      locale: string;
      subscriptionPackageText: string;
      promotionText: string;
      promotionDescriptionText: string;
    };
    type: string;
    telcoId: string;
    serviceType: string;
    billingFrequency: number;
    priceDetails: {
      chargePrice: number;
      chargeCurrency: string;
      displayPrice: number;
      displayCurrency: string;
      discountAmount: number;
    };
    paymentMethods?: [
      {
        paymentMethodCode: string;
        childPackages?: [
          {
            subscriptionPackageId: string;
            priceDetails: {
              displayPrice: number;
              displayCurrency: string;
            };
          }
        ];
      }
    ];
    status: string;
    promotionId: string;
    freeTrialLength: number;
    appStoreId: string;
    googlePlayStoreId: string;
  }[];
}
